//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from './FMPSelect';
import { regions } from '../../libs/stationRegions';

class FMPStationRegionPicker extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			disabled,
			contained,
			includeAll,
		} = this.props;

		const options = includeAll ? [{ display: 'All', value: 'all' }, ...regions] : regions;

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				md={md}
				helpText={helpText}
				disabled={disabled}
				contained={contained}
				includeAll={includeAll}
			/>
		);
	}
}

FMPStationRegionPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	md: PropTypes.number,
	helpText: PropTypes.string,
	productTypes: PropTypes.array,
	disabled: PropTypes.bool,

	dataDumpMap: PropTypes.object,
	contained: PropTypes.bool,
	includeAll: PropTypes.bool,
};

FMPStationRegionPicker.defaultProps = {
	md: 12,
	label: 'Select Region',
};
export default FMPStationRegionPicker;
